// extracted by mini-css-extract-plugin
export var documentation = "_hq-1";
export var menu = "_hq-0";